// extracted by mini-css-extract-plugin
export default {"container":"loader_with_text-module__container--1WhY9","text":"loader_with_text-module__text--U8SFk"};